import secureStorage from "../utils/SecureStorage";
import config from "../configs/config.app";
import { tools } from "../utils/tools";
import _ from "lodash";
const ServiceStorage = {
  setToken: (accessToken, refreshToken = null) => {
    secureStorage.setItem(config.accessToken, accessToken);
    secureStorage.setItem(config.refreshToken, refreshToken);

    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      localStorage.setItem(config.accessToken + "_DEV", accessToken);
      localStorage.setItem(config.refreshToken + "_DEV", refreshToken);
    }
  },

  setUserInfo: (userInfo) => {
    secureStorage.setItem(config.userInfo, userInfo);

    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      localStorage.setItem(config.userInfo + "_DEV", JSON.stringify(userInfo));
    }
  },
  getUserInfo: () => {
    return secureStorage.getItem(config.userInfo);
  },
  getAccessToken: () => {
    return secureStorage.getItem(config.accessToken);
  },

  getRefreshToken: () => {
    return secureStorage.getItem(config.refreshToken);
  },

  clearToken: () => {
    secureStorage.clear();
    localStorage.clear();
  },
  clearTokenLogin: () => {
    secureStorage.clear();
    // فقط آیتم‌های مربوط به لاگین را حذف کن، نه کل localStorage
    localStorage.removeItem("token"); 
    localStorage.removeItem("user"); 
  },
  setCity: (item) => {
    localStorage.setItem(
      "city",
      JSON.stringify({
        cityListLastUpdate: item.cityListLastUpdate,
        cityList: JSON.stringify(item.cityList),
        selectedCity: item.selectedCity,
      })
    );
  },
  getCity: () => {
    return tools.jsonDecode(localStorage.getItem("city"));
  },
  getSelectedCity: () => {
    let city = tools.jsonDecode(localStorage.getItem("city"));
    if (
      !_.isNil(city) &&
      _.has(city, "selectedCity") &&
      !_.isNil(city?.selectedCity)
    )
      return city?.selectedCity;
    else return null;
  },
  setSelectedCity: (selectedCity) => {
    let city = tools.jsonDecode(localStorage.getItem("city"));
    if (
      !_.isNil(city) &&
      _.has(city, "selectedCity") &&
      !_.isNil(city?.selectedCity)
    ) {
      localStorage.setItem(
        "city",
        JSON.stringify({ ...city, selectedCity: selectedCity })
      );
    }
  },
};

export default ServiceStorage;
